import styled from "styled-components";
import Header from "@/pages/Home/Header/Header";
import { useEffect, useState } from "react";
import HeaderFixed from "./HeaderFixed";
import Tabs from "./Tabs";
import { ImportContent } from "@/components/ImportModal";
import ImportVideoModal from "@/components/ImportVideoModal";
import JzImage from "@/components/JzImage";

const ContainerStyled = styled.div`
  position: relative;
  background: #C2E3F5;
  height: 420px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header-tabs {
    width: 724px;
    margin: 0 auto;

    position: absolute;
    left: 0;
    right: 0;
    top: 180px;
  }
`;
const NavContainerStyled = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
`
const NavTextStyled = styled.div`
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;
  padding-top: 17px;
  padding-bottom: 9px;
  ${props => props.$isActive ? 'border-bottom: 2px solid #FFFFFF;' : ''}
`
const TitleStyled = styled.div`
  position: absolute;
  top: 80px;
  right: 0;
  left: 0;
  text-align: center;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 36px;
  letter-spacing: 3px;
`
const TitleDesStyled = styled.div`
  position: absolute;
  top: 132px;
  right: 0;
  left: 0;
  text-align: center;

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 16px;
  letter-spacing: 2px;
`
const SearchPositionStyled = styled.div`
  /* position: absolute;
  top: 205px;
  right: 0;
  left: 0; */
  display: flex;
  justify-content: center;
`
const SearchContainerStyled = styled.div`
  width: 724px;
  height: 60px;
  background: #FFFFFF;
  border-radius: 10px;
  border-top-left-radius: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 2px 16px 0px #9DCBDC;
`
const InputStyled = styled.input`
  flex-grow: 1;
  flex-shrink: 0;
  padding: 0 28px;
  height: 60px;
  border: none;
  outline: none;
  font-size: 16px;


  ::placeholder {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 16px;
  }
`
const SearchButtonStyled = styled.div`
  flex-shrink: 0;
  width: 114px;
  height: 50px;
  background: #00BCA6;
  border-radius: 6px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 50px;
  text-align: center;
  letter-spacing: 1px;
  margin-right: 5px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`
const TagContainerStyled = styled.div`
  
  margin-top: 50px;
  display: flex;
  justify-content: center;
`
const TagTextStyled = styled.div`
  margin-right: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
  cursor: pointer;
  transition: all 200ms;

  ${props => props.hover && `
    &:hover {
      color: #11BBA6;
    }
  `}
  
`
const tagList = ['大学生简历模板', '实习生简历模板', '求职简历模板', '免费简历模板', '社招简历']

export default ({ onUpdateValueAndSearch, fixedHeaderVisible, searchValue }) => {
    const [value, setValue] = useState('')
    const [activeTab, setActiveTab] = useState('first');
    const [visible, setVisible] = useState(false)
    useEffect(() => {
        setValue(searchValue)
    }, [searchValue])
    const handleChange = (e) => {
        setValue(e.target.value)
    }

    const handleSearch = (value) => {
        setValue(value)
        onUpdateValueAndSearch(value)
    }

    function handleKeyDown(event) {
        if (event.keyCode === 13) {
            handleSearch(value)
        }
    }

    return <ContainerStyled>
        <JzImage style={{ position: 'absolute', height: '100%', left: '50%', transform: 'translateX(-50%)'}} src="cxkjvnkjxcnvkjx123.png" />
        {
            fixedHeaderVisible && <HeaderFixed onKeyDown={handleKeyDown} value={value} onChange={(e) => setValue(e.target.value)} onSearch={() => handleSearch(value)} />
        }
        <Header />
        <NavContainerStyled>
        </NavContainerStyled>
        <TitleStyled>优秀的简历模板，高效更专业！</TitleStyled>
        <TitleDesStyled>让每次投递都能收到面试邀请</TitleDesStyled>

        <Tabs className={"header-tabs"} value={activeTab} onChange={(value) => setActiveTab(value)}>
            <Tabs.List>
                <Tabs.Tab value="first">搜索简历</Tabs.Tab>
                <Tabs.Tab value="second">导入简历</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="first">
                <SearchPositionStyled>
                    <SearchContainerStyled>
                        <InputStyled onKeyDown={handleKeyDown} value={value} onChange={handleChange} placeholder="在1000+专业简历中搜索" />
                        <SearchButtonStyled onClick={() => onUpdateValueAndSearch(value)}>搜索模板</SearchButtonStyled>
                    </SearchContainerStyled>
                </SearchPositionStyled>
                <TagContainerStyled>
                    <TagTextStyled>搜索模板:</TagTextStyled>
                    {tagList.map((text) => <TagTextStyled hover onClick={() => handleSearch(text)} key={text}>{text}</TagTextStyled>)}
                </TagContainerStyled>
            </Tabs.Panel>
            <Tabs.Panel value="second">
                <div className="py-16" style={{ background: '#FFF', borderRadius: 10, boxShadow: '0px 2px 16px 0px #9DCBDC' }}>
                    <ImportContent isHome onClickVideo={() => setVisible(true)} style={{ marginBottom: 12 }} contentStyle={{ height: 80 }} />
                </div>
            </Tabs.Panel>
        </Tabs>

        <ImportVideoModal isHome visible={visible} onCancel={() => setVisible(false)} />
    </ContainerStyled>

}
